import React from 'react';
import { AwarenessTemplate } from '../components/training/templates/AwarenessTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getAwarenessContent } from '../data/standards/trainingContent';

export const ISO13485Awareness = () => {
  const standard = getStandardBySlug('iso-13485');
  const content = getAwarenessContent('iso-13485');

  return <AwarenessTemplate standard={standard} content={content} />;
};
